export default __webpack_public_path__ + "static/media/Marathi_af_2.78f34f31.mp3";